export function formatPermissionKey (serviceName, actionName) {
  return `${serviceName}::${actionName}`
}

export function hasPermissionKey (permissionKeys, serviceName, actionName) {
  if (!permissionKeys?.length) return false
  const key = formatPermissionKey(serviceName, actionName)
  return permissionKeys.includes(key)
}
